import { useState } from 'react'
import ContentHeader from '../../../Layout/ContentHeader'
import GetTicketsResolvedByUser from './components/GetTicketsResolvedByUser'
import GetAverageTimeOfCreateReportCitizen from './components/GetAverageTimeOfCreateReportCitizen'
import GetAverageTimeOfAttention from './components/GetAverageTimeOfAttention'
import GetAverageTimeByStatusId from './components/GetAverageTimeByStatusId'
import GetTicketsCount from './components/GetTicketsCount'
import Filters from './components/Filters'

const ReportsQueries = () => {
  //STATES:
  const [filters, setFilters] = useState({
    dateFrom: null,
    dateTo: null,
  })

  return (
    <>
      <ContentHeader
        title="Consultas de reportes"
        breadcrumb=""
        windowTitle="Consultas de reportes"
      />

      <div className="row">
        <div className="col-12">
          <Filters filters={filters} setFilters={setFilters} />
        </div>
        <div className="col-12">
          <GetTicketsCount filters={filters} setFilters={setFilters} />
        </div>
        <div className="col-12 col-xs-6 col-sm-7">
          <GetAverageTimeOfAttention
            filters={filters}
            setFilters={setFilters}
          />
          <GetAverageTimeOfCreateReportCitizen
            filters={filters}
            setFilters={setFilters}
          />
          <GetAverageTimeByStatusId filters={filters} setFilters={setFilters} />
        </div>
        <div className="col-12 col-xs-6 col-sm-5">
          <GetTicketsResolvedByUser filters={filters} setFilters={setFilters} />
        </div>
      </div>
    </>
  )
}

export default ReportsQueries
